import hasFullName from './utilities/hasFullName';
import hasPhones from './utilities/hasPhones';

const fto = (ftoJson) => {
  const properties = {
    ...ftoJson.attributes,
    guid: ftoJson.guid,
  };
  return Object.assign(
    properties,
    hasFullName(ftoJson.attributes),
    hasPhones(ftoJson.attributes.phones),
  );
};

export default fto;
